import { useEffect, useState } from "react";

import GiftCardMediaProvider from "~/contexts/giftcard-media";
import CrossCountry from "~/types/cross-country";
import CommonUtils from "~/utils/common-utils";
import productUtils from "~/utils/product-utils";

import Container from "../common/container";
import Grid from "../common/grid";
import ProductBeautyServices from "./product-beauty-services";
import { Breadcrumb } from "./product-breadcrumbs";
import ProductGallery from "./product-gallery";
import ProductInfo from "./product-info";
import ProductIntro from "./product-intro";
import ProductMoreInfo from "./product-more-info";
import styles from "./product-showcase.module.scss";

type Props = {
  root: CrossCountry.DetailedProduct;
  shades: CrossCountry.Product[];
  selectedShade: CrossCountry.DetailedProduct;
  breadcrumbs: Breadcrumb[];
};

export default function ProductShowcase(props: Props) {
  const [galleryIdx, setGalleryIdx] = useState(0);
  const [enabledGallery, setEnabledGallery] = useState(true);

  useEffect(() => {
    const hex = props.selectedShade?.hex_color;
    if (hex && CommonUtils.isColor(hex)) {
      const hexWithAlpha = hex + "26"; // 15% alpha
      document.body.style.setProperty("--fromRGBA", hexWithAlpha);
    }
  }, [props.selectedShade]);

  const isVirtualGiftCard = productUtils.isVirtualProduct(props.root) && productUtils.isGiftCard(props.root);

  return (
    <div className={styles.pdpGradient}>
      <Container>
        <Grid className={styles.pdpGrid}>
          <GiftCardMediaProvider config={isVirtualGiftCard ? props.root.giftCardConfig?.fields : undefined}>
            <ProductIntro
              root={props.root}
              selectedShade={props.selectedShade}
              galleryIdx={galleryIdx}
              onSelect={(i) => setGalleryIdx(i)}
              breadcrumbs={props.breadcrumbs}
              enabledGallery={enabledGallery}
              setEnabledGallery={setEnabledGallery}
            />
            <ProductGallery
              selectedShade={props.selectedShade}
              galleryIdx={galleryIdx}
              onSelect={(i) => setGalleryIdx(i)}
              enabledGallery={enabledGallery}
              setEnabledGallery={setEnabledGallery}
            />
            <ProductInfo root={props.root} selectedShade={props.selectedShade} shades={props.shades} />
          </GiftCardMediaProvider>
          <ProductMoreInfo selectedShade={props.selectedShade} />
          <ProductBeautyServices root={props.root} selectedShade={props.selectedShade} />
        </Grid>
      </Container>
    </div>
  );
}
